import {
  getDocumentFromDB,
  getDocumentsFromDB,
} from "./CommonUtils";
import { BLOCK } from "./Constants";
import DBMaster from "../database/dbMaster";

export const dbGiCityCollection = 'gi_city';
export const dbGiFlightsNodeCollection = 'gi_flights_node';
export const dbGiAirportCollection = 'gi_airports';
export const dbGiOffersCollection = 'gi_offers';
export const dbIntlCountryCollection = 'intl_country';

export const dbGiAirlineCollection = 'gi_airlines';
export const dbRouteDistanceCollection = 'route_distance';
export const dbGiStaticPagesTemplateCollection = 'gi_static_pages_template';

// Consolidated database connection function using DBMaster singleton
async function getSEOMongoDBInstance() {
  try {
    return await DBMaster.getDatabase();
  } catch (error) {
    console.error('Error getting SEO MongoDB instance:', error);
    return null;
  }
}


export const getGICities = async (isInternational = false) => {
  const query = { airport_flag: true };
  const city = await getDocumentsFromDB(dbGiCityCollection, query);
  if (!isInternational) {
    return city.filter(city => city.country_id === 'IN');
  }
  return city;
};

export const getAllGIAirlines = async () => {
  const airlines = await getDocumentsFromDB(dbGiAirlineCollection, {});
  return airlines;
};

export const getAllStaticPages = async () => {
  const staticPages = await getDocumentsFromDB(dbGiStaticPagesTemplateCollection, {});
  return staticPages;
};

export const getGIBlocksDataByTitle = async (title) => {
  const block = await getDocumentFromDB(BLOCK, title);
  return block;
};

export const getGICityByFlightsUrlPhrase = async (urlPhrase) => {
  const city = await getDocumentFromDB(dbGiCityCollection, { flights_url_phrase: urlPhrase });
  return city;
};

export const getGICityByFlightCityCode = async (flightCityCode) => {
  const city = await getDocumentFromDB(dbGiCityCollection, { flight_city_code: flightCityCode });
  return city;
};

export const getGIFlightNodeByURL = async (urlPhrase) => {
  const flightNode = await getDocumentsFromDB(dbGiFlightsNodeCollection, { url: urlPhrase });
  return flightNode;
};

export const getGIAirportForCityCode = async (cityCode) => {
  const airport = await getDocumentsFromDB(dbGiAirportCollection, { code: cityCode });
  return airport;
};

export const getGITemplateByType = async (dataMap, templateType) => {
  const template = await getDocumentFromDB('gidftemplate', { template_type: templateType });
  return template;
};

export const getGIStaticTemplateByType = async (templateType) => {
  const template = await getDocumentFromDB('gi_static_pages_template', { template_type: templateType });
  return template;
};

export const getFAQDataByTemplate = async (template) => {
  const data = await getDocumentFromDB('acg', { template });
  return data;
};

export const getOffersByTemplate = async (template, url) => {
  const data = await getDocumentsFromDB(dbGiOffersCollection);
  return data;
};

export const getGIIntlCountryByUrlPhrase = async (urlPhrase) => {
  const country = await getDocumentFromDB(dbIntlCountryCollection, { url_phrase: urlPhrase });
  return country;
};

export const getGIIntlCountryByCode = async (countryCode) => {
  const country = await getDocumentFromDB(dbIntlCountryCollection, { code: countryCode });
  return country;
};

export const getGIIntlCountryByCodeAndShowCountryPage = async (countryCode, showCountryPage) => {
  const country = await getDocumentFromDB(dbIntlCountryCollection, { code: countryCode.toUpperCase() });
  if (!country || country?.show_country_page !== showCountryPage) {
    return null;
  }
  return country;
};

export const getGIAirlineByUrlPhrase = async (airlineUrlPhrase) => {
  const airline = await getDocumentFromDB(dbGiAirlineCollection, { url_phrase: airlineUrlPhrase });
  return airline;
};

// OLD
export async function getCityData(template, isIntl = false) {
  if (!template) {
    return [];
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const cityCollection = await seoDB.collection(dbGiCityCollection);
  const query = !isIntl ? { airport_flag: true, country_id: 'IN' } : { airport_flag: true };
  const results = await cityCollection.find(query).toArray();
  if (!results) {
    return [];
  }
  return results;
}

export async function getCountryCode(template, isIntl = false) {
  if (!template) {
    return [];
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const cityCollection = await seoDB.collection(dbIntlCountryCollection);
  const query = { url_phrase: template };
  const results = await cityCollection.find(query).toArray();
  if (!results) {
    return [];
  }
  return results;
}

async function getNodeData(url) {
  if (!url) {
    return {};
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return {};
  }
  const nodeDataCollection = await seoDB.collection(dbGiFlightsNodeCollection);
  const results = await nodeDataCollection.findOne({ url });
  if (!results) {
    return {};
  }
  return results;
}

const checkIfDateExistsBetweenStartAndEndDate = (startDate, endDate) => {
  const todayDate = new Date();
  return todayDate >= startDate && todayDate <= endDate;
};

async function getOffersFromDB(template, url) {
  if (!url && !template) {
    return [];
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const offersDataCollection = await seoDB.collection(dbGiOffersCollection);
  const offersList = await offersDataCollection.find({}).toArray();
  if (!offersList) {
    return [];
  }
  const offers = [];
  for (let i = 0; i < offersList.length; i++) {
    const offerData = offersList[i];
    const {
      url: urlString,
      valid_from: startDate,
      valid_to: endDate,
      html,
      content_type
    } = offerData;
    const urls = urlString ? urlString.split(',') : [];
    if (urls.includes(url) || content_type === template) {
      if (checkIfDateExistsBetweenStartAndEndDate(new Date(startDate), new Date(endDate))) {
        offers.push(html);
      }
    }
  }
  return offers;
}

async function getTemplateData(template_type) {
  if (!template_type) {
    return [];
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const dfTemplateCollection = await seoDB.collection('gidftemplate');
  const results = await dfTemplateCollection.findOne({ template_type });
  if (!results) {
    return {};
  }
  return results;
}

async function getStaticLinks(template, isGroundup = false) {
  if (!template) {
    return [];
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const {
    topSectorsTitle,
    topSectorsFromSourceTitle,
    topSectorsToDestinationTitle,
    udaanSectorsTitle,
    intlFlightsFromSourceTitle,
    intlFlightsToDestinationTitle,
    domAirlinesTitle,
    intlAirlinesTitle,
    topAirlinesTitle,
    popularSectorsTitle,
    offerOverlayTitle,
    flightInfoTitle,
    flightInfoTitleGroundUp,
    cheapFlightsContentTitle,
    topDomRoutesTitle,
    topIntlRoutesTitle,
    topIntlCitiesTitle,
    topIntlRouteAirlinesTitle,
    ifTemplateLevelContentTitle,
    popularLongHaulFlightsTitle,
    topCountriesListTitle
  } = template;
  const blockCollection = await seoDB.collection('block');
  const topSectors = topSectorsTitle ? await blockCollection.findOne(topSectorsTitle) : [];
  const topSectorsFromSource = topSectorsFromSourceTitle
    ? await blockCollection.findOne(topSectorsFromSourceTitle)
    : null;
  const topSectorsToDestination = topSectorsToDestinationTitle
    ? await blockCollection.findOne(topSectorsToDestinationTitle)
    : null;
  const udaanSectors = udaanSectorsTitle ? await blockCollection.findOne(udaanSectorsTitle) : [];
  const domAirlines = domAirlinesTitle ? await blockCollection.findOne(domAirlinesTitle) : [];
  const intlAirlines = intlAirlinesTitle ? await blockCollection.findOne(intlAirlinesTitle) : [];
  const topAirlines = topAirlinesTitle ? await blockCollection.findOne(topAirlinesTitle) : [];
  const popularSectors = popularSectorsTitle
    ? await blockCollection.findOne(popularSectorsTitle)
    : [];
  const offerOverlay = offerOverlayTitle ? await blockCollection.findOne(offerOverlayTitle) : [];
  let flightInfo;
  if (isGroundup) {
    flightInfo = flightInfoTitleGroundUp
      ? await blockCollection.findOne(flightInfoTitleGroundUp)
      : {};
    if (flightInfo?.['api_url']) {
      try {
        flightInfo.api_url = JSON.parse(flightInfo.api_url);
      } catch (error) {
        console.log('error in parsing api url', error);
      }
    }
  } else {
    flightInfo = flightInfoTitle ? await blockCollection.findOne(flightInfoTitle) : {};
  }

  const cheapFlightsContent = cheapFlightsContentTitle
    ? await blockCollection.findOne(cheapFlightsContentTitle)
    : null;
  const topDomRoutes = topDomRoutesTitle ? await blockCollection.findOne(topDomRoutesTitle) : null;
  const topIntlRoutes = topIntlRoutesTitle
    ? await blockCollection.findOne(topIntlRoutesTitle)
    : null;
  const topIntlCities = topIntlCitiesTitle
    ? await blockCollection.findOne(topIntlCitiesTitle)
    : null;
  const topIntlRouteAirlines = topIntlRouteAirlinesTitle
    ? await blockCollection.findOne(topIntlRouteAirlinesTitle)
    : null;
  const intlFlightsFromSource = intlFlightsFromSourceTitle
    ? await blockCollection.findOne(intlFlightsFromSourceTitle)
    : null;
  const intlFlightsToDestination = intlFlightsToDestinationTitle
    ? await blockCollection.findOne(intlFlightsToDestinationTitle)
    : null;
  const popularLongHaulFlights = popularLongHaulFlightsTitle
    ? await blockCollection.findOne(popularLongHaulFlightsTitle)
    : null;
  const ifTemplateLevelContent = ifTemplateLevelContentTitle
    ? await blockCollection.findOne(ifTemplateLevelContentTitle)
    : null;
  const topCountriesList = topCountriesListTitle
    ? await blockCollection.findOne(topCountriesListTitle)
    : '';
  return {
    topSectors,
    topSectorsFromSource,
    topSectorsToDestination,
    udaanSectors,
    intlFlightsFromSource,
    intlFlightsToDestination,
    domAirlines,
    intlAirlines,
    topAirlines,
    popularSectors,
    offerOverlay,
    flightInfo,
    cheapFlightsContent,
    topDomRoutes,
    topIntlRoutes,
    topIntlCities,
    topIntlRouteAirlines,
    popularLongHaulFlights,
    ifTemplateLevelContent,
    topCountriesList:
      topCountriesList && topCountriesList.api_url ? topCountriesList.api_url.split(',') : []
  };
}

async function getRoadDistance(src, dest) {
  if (!src || !dest) {
    return 0;
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const routeDistanceCollection = await seoDB.collection(dbRouteDistanceCollection);
  const road_distance = await routeDistanceCollection.findOne({
    src_city_code: src,
    dest_city_code: dest
  });
  const distance = road_distance.distance ? +road_distance.distance : 0;
  return Math.round(distance * 0.001); // Converting meter distance to Km
}

async function getAirportDetails(template, city, queryType, query) {
  if (!template) {
    return [];
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const blockCollection = await seoDB.collection(dbGiAirportCollection);
  const cityAirport = await blockCollection.findOne({ code: city });
  if (!cityAirport) {
    const error_msg = `Airport with ${city} code is not found in cms`;
    const cms_error_type = 'Airport not found';
    // pushToNewRelic({ error_msg, query, queryType, cms_error_type, error_value: city });
  }
  return cityAirport;
}

async function getAirLineDetails(airline, queryType, query) {
  if (!airline) {
    return {};
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return {};
  }
  const blockCollection = await seoDB.collection(dbGiAirlineCollection);
  const airlineInfo = await blockCollection.findOne({ url_phrase: airline });
  if (!airlineInfo) {
    const error_msg = `${airline} airline is not found in cms`;
    const cms_error_type = 'Airline not found';
    // pushToNewRelic({ error_msg, query, queryType, cms_error_type, error_value: airline });
  }
  return {
    airlineInfo
  };
}

export async function getAirLineUrlPhrases() {
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const blockCollection = await seoDB.collection(dbGiAirlineCollection);
  const airlines = await blockCollection.find({}).toArray();
  if (!airlines) {
    return [];
  }
  const airlinesList = [];
  for (let i = 0; i < airlines.length; i++) {
    if (airlines[i].url_phrase) {
      airlinesList.push(airlines[i].url_phrase);
    }
  }
  return airlinesList;
}

export async function getIntlSectorsForSitemap(query) {
  const template = dbTemplateConfig[query];
  if (!template) {
    return [];
  }
  const { sectorsTitle } = template;
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const blockCollection = await seoDB.collection('block');
  const intlSitemapSectorsString = await blockCollection.findOne(sectorsTitle);
  if (!intlSitemapSectorsString || !intlSitemapSectorsString.api_url) {
    return [];
  }
  return intlSitemapSectorsString.api_url.split(',');
}

export async function getStaticTemplateData(staticPageName) {
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return {};
  }
  const staticPagesTemplateCollection = await seoDB.collection(dbGiStaticPagesTemplateCollection);
  const staticpageTemplate = await staticPagesTemplateCollection.findOne({
    url: `${staticPageName}.htm`
  });
  if (!staticpageTemplate) {
    const error_msg = `${staticPageName}.htm static page is not found in cms`;
    const cms_error_type = 'static page not found';
    // pushToNewRelic({ error_msg, cms_error_type, error_value: staticPageName });
    return {};
  }
  return staticpageTemplate;
}

export async function getStaticPagesNames() {
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const staticPagesTemplateCollection = await seoDB.collection(dbGiStaticPagesTemplateCollection);
  const staticPages = await staticPagesTemplateCollection.find({}).toArray();
  if (!staticPages) {
    return [];
  }
  return staticPages.map(staticPage => {
    return staticPage.url;
  });
}

export async function getStaticBlockLinks(staticLinksTitles) {
  if (!staticLinksTitles || staticLinksTitles.length === 0) {
    return [];
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const blockCollection = await seoDB.collection('block');
  return Promise.all(
    staticLinksTitles.map(async staticLinksTitle => {
      return staticLinksTitle ? await blockCollection.findOne({ title: staticLinksTitle }) : [];
    })
  );
}

export async function getDestinationAndAirline(destCity, airline) {
  const destinationAndAirline = `${destCity}-${airline}`;
  const destinationAndAirlineStrings = destinationAndAirline.split('-');
  const airlinesList = await getAirLineUrlPhrases();
  let airlineName = '';
  for (let i = destinationAndAirlineStrings.length - 1; i >= 0; i--) {
    airlineName =
      airlineName === ''
        ? destinationAndAirlineStrings[i]
        : `${destinationAndAirlineStrings[i]}-${airlineName}`;
    const airlineFound = airlinesList.includes(airlineName);
    if (airlineFound) {
      let destinationName = destinationAndAirlineStrings[0];
      for (let index = 1; index < i; index++) {
        destinationName = `${destinationName}-${destinationAndAirlineStrings[index]}`;
      }
      return { destinationName, airlineName };
    }
  }
  return { destinationName: destCity, airlineName: airline };
}

export async function getSeoData(
  queryType,
  srcCity,
  destCity,
  airline,
  query,
  isGroundup
) {
  if (queryType === '') {
    return {};
  }
  const { templateType, faqTemplate, staticInformation, path } = dbTemplateConfig[queryType];
  const url = getCurrentUrl({ path, srcCity, destCity, airline });
  const [
    routeDataResponse,
    nodeRouteDataResponse,
    cityDataResponse,
    faqDataResponse,
    staticDataResponse,
    airlineDataResponse,
    offersDataResponse
  ] = await Promise.all([
    getTemplateData(templateType),
    getNodeData(url),
    getCityData(queryType),
    getFAQData(faqTemplate),
    getStaticLinks(staticInformation, isGroundup),
    getAirLineDetails(airline, queryType, query),
    getOffersFromDB(templateType, url)
  ]);

  const {
    meta_title,
    meta_description,
    meta_android_alternate_tag: meta_canonical_tag,
    breadcrumb,
    h_1_header,
    footer_data,
    cheap_fare_table_data,
    seo_content,
    flight_info,
    weight,
    content
  } = nodeRouteDataResponse
    ? replaceTemplateValuesWithNodeValuesIfPresent(routeDataResponse, nodeRouteDataResponse)
    : routeDataResponse;
  const cityDataList = cityDataResponse;
  const faqData = faqDataResponse;
  const {
    topSectors = [],
    topSectorsFromSource,
    topSectorsToDestination,
    udaanSectors = [],
    popularLongHaulFlights = [],
    intlFlightsFromSource = [],
    intlFlightsToDestination = [],
    domAirlines = [],
    topAirlines = [],
    popularSectors = [],
    offerOverlay,
    flightInfo
  } = staticDataResponse;
  const {
    topCities,
    src,
    dest,
    sourceLinkedData,
    destLinkedData,
    srcDistanceData,
    destDistanceData,
    srcArticle,
    destArticle,
    aerial_distance
  } = processCityData(cityDataList, srcCity, destCity, queryType, query);
  const road_distance =
    queryType === 'distance' ? await getRoadDistance(src.city_code, dest.city_code) : null;
  const {
    flightInfo: finalFlightInfo,
    faqData: finalFaqs,
    srcArticle: aboutSource,
    destArticle: aboutDestination
  } = processNodeData(flightInfo, faqData, srcArticle, destArticle, nodeRouteDataResponse);
  const { airlineInfo = {} } = airlineDataResponse;
  const sourceAirport = await getAirportDetails(queryType, src.flight_city_code, queryType, query);
  const destinationAirport = await getAirportDetails(
    queryType,
    dest.flight_city_code,
    queryType,
    query
  );
  const hrefLangData = getHrefLangData({ src, dest, airline, queryType });
  return {
    meta_title,
    meta_description,
    meta_canonical_tag,
    breadcrumb: breadcrumb ? JSON.parse(breadcrumb) : null,
    h_1_header,
    footer_data,
    offersFromDb: offersDataResponse,
    extraContentPosition: weight,
    extraContent: content,
    cheap_fare_table_data,
    sourceLinkedData,
    destLinkedData,
    srcDistanceData,
    destDistanceData,
    src,
    dest,
    srcArticle: aboutSource,
    destArticle: aboutDestination,
    aerial_distance,
    road_distance,
    seo_content,
    topSectors,
    topSectorsFromSource: topSectorsFromSource ? JSON.parse(topSectorsFromSource.api_url) : [],
    topSectorsToDestination: topSectorsToDestination
      ? JSON.parse(topSectorsToDestination.api_url)
      : [],
    popularLongHaulFlights,
    udaanSectors,
    intlFlightsFromSource,
    intlFlightsToDestination,
    domAirlines,
    topAirlines,
    popularSectors,
    offerOverlay,
    flightInfo: finalFlightInfo,
    airlineInfo,
    sourceAirport,
    destinationAirport,
    hrefLangData,
    faqs: finalFaqs,
    flight_info,
    hasSeoData: getSEOMongoDBInstance() === null ? false : true
  };
}

export async function getFlightsToFlightsFromSeoData(
  queryType,
  city,
  query
) {
  if (queryType === '') {
    return {};
  }
  const isInternational = queryType.includes('international') ? true : false;
  const isFlightsTo = queryType && queryType.includes('flights-to') ? true : false;
  const { templateType, staticInformation, path } = dbTemplateConfig[queryType];
  const [routeDataResponse, nodeRouteDataResponse, cityDataResponse, staticDataResponse] =
    await Promise.all([
      getTemplateData(templateType),
      getNodeData(getCurrentUrl({ path, city })),
      getCityData(queryType, isInternational),
      getStaticLinks(staticInformation)
    ]);
  const {
    meta_title,
    meta_description,
    meta_android_alternate_tag: meta_canonical_tag,
    breadcrumb,
    h_1_header,
    footer_data,
    seo_content,
    weight,
    content
  } = nodeRouteDataResponse
    ? replaceTemplateValuesWithNodeValuesIfPresent(routeDataResponse, nodeRouteDataResponse)
    : routeDataResponse;
  const cityDataList = cityDataResponse;
  const { offerOverlay, topIntlRoutes = [], topIntlCities = [] } = staticDataResponse;
  const { topCities, src, dest, cityLinkedData, allFlightsToCities } =
    processFlightsToFlightsFromCityData(cityDataList, city, queryType, query);
  const cityData = isFlightsTo ? dest : src;
  const cityAirport = await getAirportDetails(
    queryType,
    cityData.flight_city_code,
    queryType,
    query
  );
  const hrefLangData = getHrefLangData({ city: cityData, queryType });
  let hasSeoData = true;
  if (isInternational && cityData && cityData.country_id === 'IN') {
    hasSeoData = false;
  }
  return {
    meta_title,
    meta_description,
    meta_canonical_tag,
    breadcrumb: breadcrumb ? JSON.parse(breadcrumb) : null,
    h_1_header,
    footer_data,
    hrefLangData,
    extraContentPosition: weight,
    extraContent: content,
    topCities,
    cityLinkedData,
    allFlightsToCities,
    src,
    dest,
    seo_content,
    offerOverlay,
    cityAirport,
    ...(isInternational ? { topIntlRoutes, topIntlCities } : null),
    hasSeoData
  };
}

export async function getAirlinesSeoData(airline, queryType, query) {
  if (queryType === '') {
    return {};
  }
  const { templateType, staticInformation, path } = dbTemplateConfig[queryType];
  const [
    routeDataResponse,
    nodeRouteDataResponse,
    cityDataResponse,
    staticDataResponse,
    airlineDataResponse
  ] = await Promise.all([
    getTemplateData(templateType),
    getNodeData(getCurrentUrl({ path, airline })),
    getCityData(queryType, true),
    getStaticLinks(staticInformation),
    getAirLineDetails(airline, queryType, query)
  ]);
  const {
    meta_title,
    meta_description,
    meta_android_alternate_tag: meta_canonical_tag,
    breadcrumb,
    h_1_header,
    footer_data,
    weight,
    content
  } = nodeRouteDataResponse
    ? replaceTemplateValuesWithNodeValuesIfPresent(routeDataResponse, nodeRouteDataResponse)
    : routeDataResponse;
  const cityDataList = cityDataResponse;
  const { domAirlines = [], offerOverlay } = staticDataResponse;
  const { airlineInfo = {} } = airlineDataResponse;
  const { name: airlineName } = airlineInfo;
  const {
    domesticRoutes,
    internationalRoutes,
    airlineDomRoutes,
    airlineIntlRoutes,
    cheapFareDomRoutes,
    cheapFareIntlRoutes
  } = processAirlinesCityData(cityDataList, airlineInfo, airline, airlineName);
  const { src, dest } = getSrcAndDest(cityDataList, defaultSource, defaultDestination, queryType);
  return {
    src,
    dest,
    meta_title,
    meta_description,
    meta_canonical_tag,
    breadcrumb: breadcrumb ? JSON.parse(breadcrumb) : null,
    h_1_header,
    footer_data,
    extraContentPosition: weight,
    extraContent: content,
    offerOverlay,
    airlineInfo,
    domesticRoutes,
    domAirlines,
    internationalRoutes,
    seo_content: airlineInfo?.seo_content,
    airlineDomRoutes,
    airlineIntlRoutes,
    cheapFareDomRoutes,
    cheapFareIntlRoutes,
    hasSeoData: getSEOMongoDBInstance() === null ? false : true
  };
}

export async function getCheapFlightsSeoData(queryType) {
  if (queryType === '') {
    return {};
  }
  const { templateType, faqTemplate, staticInformation, path } = dbTemplateConfig[queryType];
  const [
    routeDataResponse,
    nodeRouteDataResponse,
    faqDataResponse,
    staticDataResponse,
    cityDataResponse
  ] = await Promise.all([
    getTemplateData(templateType),
    getNodeData(getCurrentUrl({ path })),
    getFAQData(faqTemplate),
    getStaticLinks(staticInformation),
    getCityData(queryType)
  ]);
  const {
    meta_title,
    meta_description,
    meta_android_alternate_tag: meta_canonical_tag,
    breadcrumb,
    h_1_header,
    footer_data,
    seo_content,
    weight,
    content
  } = nodeRouteDataResponse
    ? replaceTemplateValuesWithNodeValuesIfPresent(routeDataResponse, nodeRouteDataResponse)
    : routeDataResponse;
  const faqData = faqDataResponse;
  const {
    topSectors = [],
    popularSectors = [],
    domAirlines = [],
    cheapFlightsContent = []
  } = staticDataResponse;
  const cityDataList = cityDataResponse;
  const { src, dest } = getSrcAndDest(cityDataList, defaultSource, defaultDestination, queryType);
  return {
    src,
    dest,
    meta_title,
    meta_description,
    meta_canonical_tag,
    breadcrumb: breadcrumb ? JSON.parse(breadcrumb) : null,
    h_1_header,
    footer_data,
    seo_content,
    extraContentPosition: weight,
    extraContent: content,
    topSectors,
    domAirlines,
    popularSectors,
    cheapFlightsContent,
    faqs: faqData,
    hasSeoData: getSEOMongoDBInstance() === null ? false : true
  };
}

export async function getFlightScheduleSeoData(queryType) {
  if (queryType === '') {
    return {};
  }
  const { templateType, staticInformation, path } = dbTemplateConfig[queryType];
  const [routeDataResponse, nodeRouteDataResponse, staticDataResponse, cityDataResponse] =
    await Promise.all([
      getTemplateData(templateType),
      getNodeData(getCurrentUrl({ path })),
      getStaticLinks(staticInformation),
      getCityData(queryType)
    ]);
  const {
    meta_title,
    meta_description,
    meta_android_alternate_tag: meta_canonical_tag,
    breadcrumb,
    h_1_header,
    footer_data,
    weight,
    content
  } = nodeRouteDataResponse
    ? replaceTemplateValuesWithNodeValuesIfPresent(routeDataResponse, nodeRouteDataResponse)
    : routeDataResponse;
  const { topDomRoutes = [], topIntlRoutes = [] } = staticDataResponse;
  const cityDataList = cityDataResponse;
  const { src, dest } = getSrcAndDest(cityDataList, defaultSource, defaultDestination, queryType);
  return {
    src,
    dest,
    meta_title,
    meta_description,
    meta_canonical_tag,
    breadcrumb: breadcrumb ? JSON.parse(breadcrumb) : null,
    h_1_header,
    footer_data,
    extraContentPosition: weight,
    extraContent: content,
    topDomRoutes,
    topIntlRoutes,
    hasSeoData: getSEOMongoDBInstance() === null ? false : true
  };
}

export async function getSeoInternationalData(
  queryType,
  srcCity,
  destCity,
  country,
  countryId,
  airline,
  query
) {
  if (queryType === '') {
    return {};
  }
  const { templateType, faqTemplate, staticInformation, path } = dbTemplateConfig[queryType];
  const url = getCurrentUrl({
    path,
    srcCity,
    destCity,
    airline,
    country,
    countryId
  });
  const [
    routeDataResponse,
    nodeRouteDataResponse,
    cityDataResponse,
    faqDataResponse,
    staticDataResponse,
    airlineDataResponse,
    offersDataResponse
  ] = await Promise.all([
    getTemplateData(templateType),
    getNodeData(url),
    getCityData(queryType, true),
    getFAQData(faqTemplate),
    getStaticLinks(staticInformation),
    getAirLineDetails(airline, queryType, query),
    getOffersFromDB(templateType, url)
  ]);
  const {
    meta_title,
    meta_description,
    meta_android_alternate_tag: meta_canonical_tag,
    breadcrumb,
    h_1_header,
    footer_data,
    seo_content,
    weight,
    content
  } = nodeRouteDataResponse
    ? replaceTemplateValuesWithNodeValuesIfPresent(routeDataResponse, nodeRouteDataResponse)
    : routeDataResponse;
  const faqData = faqDataResponse;
  const cityDataList = cityDataResponse;
  const {
    offerOverlay,
    topIntlRoutes = [],
    topIntlCities = [],
    intlAirlines = [],
    topIntlRouteAirlines = [],
    ifTemplateLevelContent = [],
    flightInfo
  } = staticDataResponse;
  const { src, dest, srcArticle, destArticle } = getSrcAndDest(
    cityDataList,
    srcCity,
    destCity,
    queryType,
    query
  );
  const {
    flightInfo: finalFlightInfo,
    faqData: finalFaqs,
    srcArticle: aboutSource,
    destArticle: aboutDestination
  } = processNodeData(flightInfo, faqData, srcArticle, destArticle, nodeRouteDataResponse);
  const { sourceLinkedData, destLinkedData } = getIntlCityLinkedData(
    cityDataList,
    src,
    dest,
    queryType
  );
  const hrefLangData = getHrefLangData({ src, dest, airline, queryType });
  const { airlineInfo = {} } = airlineDataResponse;
  const sourceAirport = await getAirportDetails(queryType, src.flight_city_code, queryType, query);
  const destinationAirport = await getAirportDetails(
    queryType,
    dest.flight_city_code,
    queryType,
    query
  );
  let flag = true;
  if (src && dest && src.country_id === 'IN' && dest.country_id === 'IN') {
    flag = false;
  } else if (country !== '' || countryId !== '') {
    if (
      (src.country_id in targetIntlCountriesList &&
        targetIntlCountriesList[src.country_id] === country &&
        src.country_id.toLowerCase() === countryId) ||
      (dest.country_id in targetIntlCountriesList &&
        targetIntlCountriesList[dest.country_id] === country &&
        dest.country_id.toLowerCase() === countryId)
    ) {
      flag = true;
    } else {
      flag = false;
    }
  }

  return {
    meta_title,
    meta_description,
    meta_canonical_tag,
    breadcrumb: breadcrumb ? JSON.parse(breadcrumb) : null,
    h_1_header,
    offersFromDb: offersDataResponse,
    footer_data,
    seo_content,
    extraContentPosition: weight,
    extraContent: content,
    sourceLinkedData,
    destLinkedData,
    src,
    dest,
    srcArticle: aboutSource,
    destArticle: aboutDestination,
    topIntlRoutes,
    topIntlCities,
    ifTemplateLevelContent,
    topIntlRouteAirlines,
    intlAirlines,
    offerOverlay,
    flightInfo: finalFlightInfo,
    airlineInfo,
    sourceAirport,
    destinationAirport,
    faqs: finalFaqs,
    hrefLangData,
    hasSeoData: getSEOMongoDBInstance() === null || !flag ? false : true
  };
}

export async function getStaticPagesSeoData(staticPageName, queryType) {
  if (!staticPageName || staticPageName === '') {
    return {};
  }
  const staticPageTemplate = await getStaticTemplateData(staticPageName);
  const hasSeoData = Object.keys(staticPageTemplate).length === 0 ? false : true;
  if (!hasSeoData) {
    return {};
  }
  const { top_routes = '', faq = '' } = staticPageTemplate;
  const topRoutes = top_routes.split(',') || [];
  const staticBlockLinks = await getStaticBlockLinks(topRoutes);
  const parsedFaqs = faq ? JSON.parse(faq) : [];

  const [cityDataResponse] = await Promise.all([getCityData(queryType)]);
  const cityDataList = cityDataResponse;
  const { src, dest } = getSrcAndDest(cityDataList, 'delhi', 'mumbai', queryType);

  return {
    ...staticPageTemplate,
    src,
    dest,
    breadcrumb: staticPageTemplate.breadcrumb ? JSON.parse(staticPageTemplate.breadcrumb) : null,
    staticBlocks: staticBlockLinks,
    faqs: parsedFaqs,
    hasSeoData: hasSeoData
  };
}

export async function getFooterData(title) {
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return {};
  }
  const blockCollection = await seoDB.collection('block');
  // const homeFooter = await blockCollection.findOne({ title: 'GI-HP Footer' });
  const flightsFooter = await blockCollection.findOne({ title: title });
  return flightsFooter;
}

export async function getOverlayData() {
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return {};
  }
  const blockCollection = await seoDB.collection('block');
  const overlayData = await blockCollection.findOne({ title: 'GI-Offer overlay SEM' });
  return overlayData;
}

export async function getTopBannerData(queryType, flavour) {
  const { templateType } = dbTemplateConfig[queryType];
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return {};
  }
  const blockCollection = await seoDB.collection('block');
  const bannerData = await blockCollection.findOne({
    title: flavour === 'PWA' ? 'GI mweb Top Banner on DF Route' : 'GI Top Banner on DF Route'
  });
  const { content_type = '' } = bannerData || {};
  if (content_type === templateType && bannerData?.api_url) {
    const bannerDetails = JSON.parse(bannerData.api_url);
    return bannerDetails.bd || {};
  }
  return {};
}

export async function getCountryData(template) {
  if (!template) {
    return [];
  }
  const seoDB = getSEOMongoDBInstance();
  if (!seoDB) {
    return [];
  }
  const countryCollection = await seoDB.collection(dbIntlCountryCollection);
  const results = await countryCollection.find({}).toArray();
  if (!results) {
    return [];
  }
  return results;
}

export async function checkIsInternational(destinationName, queryType) {
  if (!destinationName) {
    return false;
  }
  const cityData = await getCityData(queryType, true);
  if (!cityData || !cityData.find(city => city.flights_url_phrase === destinationName)) {
    return false;
  }
  return true;
}

export async function getSeoCityCountryData(
  queryType,
  srcCity,
  destCity,
  country,
  countryId,
  airline,
  query
) {
  if (queryType === '') {
    return {};
  }
  const { templateType, faqTemplate, staticInformation, path } = dbTemplateConfig[queryType];
  const url = getCurrentUrl({
    path,
    srcCity,
    destCity,
    airline,
    country,
    countryId
  });
  const [
    routeDataResponse,
    nodeRouteDataResponse,
    cityDataResponse,
    countryDataResponse,
    faqDataResponse,
    staticDataResponse
  ] = await Promise.all([
    getTemplateData(templateType),
    getNodeData(url),
    getCityData(queryType, true),
    getCountryData(queryType, true),
    getFAQData(faqTemplate),
    getStaticLinks(staticInformation)
  ]);
  const {
    meta_title,
    meta_description,
    meta_android_alternate_tag: meta_canonical_tag,
    breadcrumb,
    h_1_header,
    footer_data,
    seo_content,
    weight,
    content
  } = nodeRouteDataResponse
    ? replaceTemplateValuesWithNodeValuesIfPresent(routeDataResponse, nodeRouteDataResponse)
    : routeDataResponse;
  const cityDataList = cityDataResponse;
  const countryDataList = countryDataResponse;
  const { src, dest } = getSrcAndDest(
    cityDataList,
    srcCity,
    destCity,
    queryType,
    query,
    countryDataList
  );
  const { topCountriesList = [] } = staticDataResponse;
  const topCountriesLinkedData = getTopcountriesLinkedData(
    src,
    destCity,
    queryType,
    topCountriesList,
    10
  );
  const { sourceLinkedData } = getIntlCityLinkedData(cityDataList, src, dest, queryType);
  const hrefLangData = getHrefLangData({ src, dest, queryType });
  return {
    meta_title,
    meta_description,
    meta_canonical_tag,
    breadcrumb: breadcrumb ? JSON.parse(breadcrumb) : null,
    h_1_header,
    sourceLinkedData,
    footer_data,
    src,
    dest,
    topCountriesLinkedData,
    hrefLangData,
    faqs: faqDataResponse
  };
}
